var map = {
	"./arrowDown.svg": 452,
	"./arrowLeft.svg": 712,
	"./arrowRight.svg": 794,
	"./arrowUp.svg": 979,
	"./calendar.svg": 616,
	"./clock.svg": 469,
	"./closeBig.svg": 796,
	"./doc.svg": 5,
	"./docx.svg": 569,
	"./download.svg": 649,
	"./file.svg": 799,
	"./folder.svg": 708,
	"./info.svg": 431,
	"./pdf.svg": 716,
	"./ppt.svg": 774,
	"./pptx.svg": 728,
	"./remove.svg": 258,
	"./search.svg": 201,
	"./tick.svg": 316,
	"./upload.svg": 698,
	"./www.svg": 231
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57;